import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useTmpAuthAtom from "shared/model/useConfrimCookie"

const usePutAuthPassword = (idRef, newPwRef) => {
    const navigate = useNavigate()

    const [fetchResult, fetchRequest] = useFetch()
    const [, , deleteTmpToken] = useTmpAuthAtom()
    const [, setAlert] = useAlertModalAtom()


    const putAccountPwEvent = () => {
        fetchRequest("PUT", "/auth/password", {
            "id": idRef?.current?.value,
            "new_password": newPwRef?.current?.value
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setAlert("비밀번호 변경이 완료되었습니다.")
                navigate("/")
                break
            case 400:
                if (fetchResult?.data?.target === "id") setAlert("아이디 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.target === "new_password") setAlert("비밀번호 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                setAlert("가입된 계정이 아니거나\n다른 방법으로 가입된 계정입니다.")
                deleteTmpToken()
                break

        }
    }, [fetchResult])

    return [putAccountPwEvent]
}

export default usePutAuthPassword